module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "id": "debtorList"
    }
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "popoverName": ".popoverContacts",
      "subNavTitle": "DebtorList",
      "menuAccess": false
    }
  }), _vm._v(" "), _c('f7-searchbar', {
    staticClass: "search",
    attrs: {
      "cancel-link": "Cancel",
      "search-list": "#debtors-list",
      "placeholder": "Search in debtor list"
    },
    on: {
      "searchbar:search": _vm.onSearch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutSubtitle"
  }), _vm._v(" "), _c('f7-list', {
    staticClass: "searchbar-not-found"
  }, [_c('f7-list-item', {
    attrs: {
      "title": "Nothing found"
    }
  })], 1), _vm._v(" "), _c('f7-list', {
    staticClass: "searchbar-found",
    attrs: {
      "media-list": "",
      "id": "debtors-list"
    }
  }, _vm._l((_vm.debtors), function(debtor) {
    return _c('f7-list-item', {
      key: debtor.debtorBank,
      attrs: {
        "swipeout": "",
        "title": debtor.debtorName,
        "subtitle": debtor.debtorEmail,
        "media": '<div class=\'manualChip\'>' + _vm.contact.label[0] + '</div>'
      }
    }, [_c('f7-swipeout-actions', [_c('f7-swipeout-button', {
      attrs: {
        "delete": ""
      }
    }, [_vm._v("Delete")])], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75abd155", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75abd155","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/popups/services/payments/CMDebtorList.vue
// module id = 2462
// module chunks = 2